module.exports = __webpack_public_path__ + "static/img/3.3fddf6d0.png";